import React, { ChangeEventHandler } from 'react';

import { styled as muiStyled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

export const ERROR_COLOR = '#ff0000';

type Props = {
  startTimeText: string | undefined;
  endTimeText: string | undefined;
  toolTipText: string;
  startTimePlaceholder: string;
  endTimePlaceholder: string;
  startTimeError: boolean;
  endTimeError: boolean;
  onChangeStartTimeText: ChangeEventHandler<HTMLInputElement>;
  onChangeEndTimeText: ChangeEventHandler<HTMLInputElement>;
};

const TimeRangeTextGroup = ({
  startTimeText,
  endTimeText,
  toolTipText,
  startTimePlaceholder,
  endTimePlaceholder,
  onChangeStartTimeText,
  onChangeEndTimeText,
  startTimeError,
  endTimeError,
}: Props) => {
  return (
    <>
      <Grid item lg={2} md={3}>
        <Tooltip title={toolTipText}>
          <StyledTextField
            size="small"
            fullWidth
            value={startTimeText}
            error={startTimeError}
            placeholder={startTimePlaceholder}
            onChange={onChangeStartTimeText}
            inputProps={{ inputMode: 'numeric' }}
          />
        </Tooltip>
      </Grid>
      <DividerGrid item xs="auto">
        〜
      </DividerGrid>
      <Grid item lg={2} md={3}>
        <Tooltip title={toolTipText}>
          <StyledTextField
            size="small"
            fullWidth
            value={endTimeText}
            error={endTimeError}
            placeholder={endTimePlaceholder}
            onChange={onChangeEndTimeText}
            inputProps={{ inputMode: 'numeric' }}
          />
        </Tooltip>
      </Grid>
    </>
  );
};

export default TimeRangeTextGroup;

const DividerGrid = muiStyled(Grid)(
  ({ theme }) => `
  margin: ${theme.spacing('auto', 1, 1)};
  text-align: center;
`,
);

const StyledTextField = muiStyled(TextField)(
  ({ theme }) => `
  & .MuiOutlinedInput-input {
    text-align: center;
    background-color: #eeeeee;
    padding: ${theme.spacing(0.5, 1.25)};
  }

  & .Mui-error.MuiOutlinedInput-root .MuiOutlinedInput-input {
    color: ${ERROR_COLOR};
  }

  & .Mui-error.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: ${ERROR_COLOR};
  }
`,
);
